import { createTranscriptStore } from "@ayla/browser-state";
import type { ServerAnalysis, Transcript } from "@ayla/conversation";

export const {
  CURRENT_PING_KEY,
  CURRENT_CLEARED_EVT,
  setTranscript,
  getTranscript,
  setServerAnalysis,
  getAnalysis,
  clearCurrent,
} = createTranscriptStore<Transcript, ServerAnalysis>({
  pingKey: "engage:current:ping",
  clearedEvent: "engage:current:cleared",
});
